import React from 'react';
import { Paper, Typography, Box, LinearProgress } from '@mui/material';

export default function UploadProgressIndicator({ uploadProgress }) {
  if (!uploadProgress?.visible) {
    return null;
  }

  return (
    <Paper
      elevation={3}
      sx={{
        position: 'fixed',
        bottom: 32,
        right: 32,
        width: '400px',
        padding: 2,
        zIndex: 2000,
        borderRadius: 2,
        backgroundColor: uploadProgress.error ? 'error.light' : 'background.paper',
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
        {uploadProgress.error ? 'Upload Mislukt' : 'Bezig met uploaden...'}
      </Typography>
      
      {uploadProgress.error ? (
        <Typography variant="body2" color="error" sx={{ mb: 1 }}>
          {uploadProgress.errorMessage}
        </Typography>
      ) : (
        <>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            Bestand {uploadProgress.completedFiles + 1} van {uploadProgress.totalFiles}
          </Typography>
          <Typography variant="caption" sx={{ mb: 1, display: 'block', color: 'text.secondary' }}>
            {uploadProgress.currentFileName}
          </Typography>
          
          {/* Current file progress */}
          <Box sx={{ mb: 1.5 }}>
            <LinearProgress 
              variant="determinate" 
              value={uploadProgress.currentFileProgress} 
              color="primary"
              sx={{ height: 8, borderRadius: 1 }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
              <Typography variant="caption">
                {uploadProgress.currentFileProgress}%
              </Typography>
            </Box>
          </Box>
          
          {/* Overall progress */}
          <Typography variant="caption" sx={{ mb: 0.5, display: 'block' }}>
            Totale voortgang
          </Typography>
          <LinearProgress 
            variant="determinate" 
            value={(uploadProgress.completedFiles / uploadProgress.totalFiles) * 100}
            color="success"
            sx={{ height: 6, borderRadius: 1 }} 
          />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
            <Typography variant="caption">
              {uploadProgress.completedFiles} van {uploadProgress.totalFiles} bestanden voltooid
            </Typography>
            <Typography variant="caption">
              {Math.round((uploadProgress.completedFiles / uploadProgress.totalFiles) * 100)}%
            </Typography>
          </Box>
        </>
      )}
    </Paper>
  );
} 